// MED-1268: the Partner & Program step. Program carries a required mark, so
// the wizard requires it. Every partner can pick "+ Create new program", so a
// partner with no programs can still pass this step.
export const CREATE_NEW_PROGRAM_VALUE = '__create_new__';

export function partnerProgramErrors(values: {
  partnerId: string;
  programId: string;
  newProgramName: string;
}): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!values.partnerId) {
    errors.partnerId = 'Partner is required';
  }
  if (!values.programId) {
    errors.programId = 'Program is required';
  } else if (values.programId === CREATE_NEW_PROGRAM_VALUE && !values.newProgramName.trim()) {
    errors.newProgramName = 'New program name is required';
  }
  return errors;
}
